let mobx = require('mobx');
// create State object
let data = {
    timer: 0,
    names: ['', ''],
    user_name: '',
    user_password: '',
    email: '',
    phone_num: '',
    email_code: '',
    phone_code: '',
    phone_code_time: 0,//短信验证码有效时间
    email_code_time: 0,//短信验证码有效时间
    is_show_login_view: false,//是否显示填写验证码和登录的按钮
    login_type: '',
}
let loginState = mobx.observable(data);

// export default loginState;
module.exports = loginState;